import { useFormContext } from 'react-hook-form';
import _ from '@lodash';
import { Button } from '@material-ui/core';
import RacsTesztlapService from 'app/admin/racstesztlap/service/RacsTesztlapService';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useHistory, withRouter } from 'react-router';
import { useSheetCorrection } from './SheetCorrectionProvider';

function SheetCorrectionHeader(props) {
	const history = useHistory();
	const dispatch = useDispatch();
	const { data } = useSheetCorrection();
	const { getValues } = useFormContext();

	const handleSave = () => {
		RacsTesztlapService.setSheetCorrection(getValues('id'), data).then(resp => {
			if (resp) {
				dispatch(showMessage({ message: 'Sikeres rögzítés.' }));
				history.push('/tesztlapok');
			} else {
				dispatch(showMessage({ message: 'Hiba történt a koordináták rögzítése során.' }));
			}
		});
	};

	return (
		<div className="mt-8 flex flex-1 flex-row justify-between">
			<div className="mx-8">
				<Button variant="contained" color="secondary" onClick={e => handleSave()} disabled={data.length === 0}>
					Beküldés
				</Button>
			</div>
			<div className="flex flex-col">
				<div className="flex flex-row">
					<div className="w-12 h-12 bg-green-800 m-4" />
					<div className="w-12 h-12 border-1 border-green-800 m-4" />
					<div className="mx-8 flex flex-wrap content-center">Helyes, gép javította</div>
				</div>
				<div className="flex flex-row">
					<div className="w-12 h-12 bg-green-800 m-4 rounded-xl" />
					<div className="w-12 h-12 border-1 border-green-800 m-4 rounded-xl" />
					<div className="mx-8 flex flex-wrap content-center">Helyes, kézzel javított</div>
				</div>
				<div className="flex flex-row">
					<div className="w-12 h-12 bg-red-800 m-4" />
					<div className="w-12 h-12 border-1 border-red-800 m-4" />
					<div className="mx-8 flex flex-wrap content-center">Hibás, gép javította</div>
				</div>
				<div className="flex flex-row">
					<div className="w-12 h-12 bg-red-800 m-4 rounded-xl" />
					<div className="w-12 h-12 border-1 border-red-800 m-4 rounded-xl" />
					<div className="mx-8 flex flex-wrap content-center">Hibás, kézzel javított</div>
				</div>
				<div className="flex flex-row">
					<div className="w-12 h-12 bg-yellow-800 m-4" />
					<div className="w-12 h-12 border-1 border-yellow-800 m-4" />
					<div className="mx-8 flex flex-wrap content-center">Problémás, gép javította</div>
				</div>
				<div className="flex flex-row">
					<div className="w-12 h-12 bg-yellow-800 m-4 rounded-xl" />
					<div className="w-12 h-12 border-1 border-yellow-800 m-4 rounded-xl" />
					<div className="mx-8 flex flex-wrap content-center">Problémás, kézzel javított</div>
				</div>
			</div>
		</div>
	);
}

export default withRouter(SheetCorrectionHeader);
